define('bizzabo/views/right/AgendaErrorsView',[
    'backbone',
    'bizzabo/config',
    'bizzabo/models/Global',
    'bizzabo/views/popup/EditSpeakerView',
    'hbars!bizzabo/templates/agendaErrors'
], function(
    Backbone,
    CONFIG,
    Global,
    EditSpeakerView,
    template
    ) {

    var AgendaErrorsView = Backbone.View.extend({

        events: {
            'click .agenda-errors-item-speaker': 'speakerClicked'
        },

        initialize: function() {
            this.listenTo(this.model, 'agendaValidated', _.debounce(this.render, 500));
        },

        speakerClicked: function(e) {
            var cid = $(e.currentTarget).attr('data-cid');
            var speaker = this.model.get('speaker').get(cid);
            new EditSpeakerView({
                model : speaker
            }).show();
        },

        sessionInstructions: {
            start: 'Adjust the start time of the session',
            end: 'Adjust the end time of the session',
            duration: 'Adjust the start time or end time of the session',
            name: 'Adjust the title of the session',
            description: 'Adjust the description of the session',
            location: 'Adjust the location of the session',
            isColliding: 'Change the time of the sessions or place them on different tracks',
            invalidSpeaker: 'Edit the speaker in this session'
        },

        speakerInstructions: {
            'first-name': 'Adjust the first name of the speaker',
            'last-name': 'Adjust the last name of the speaker',
            'title': 'Adjust the title of the speaker',
            'company': 'Adjust the company of the speaker',
            'website': 'Adjust the website of the speaker',
            'blog': 'Adjust the blog of the speaker',
            'linkedin-profile-url': 'Adjust the Linkedin profile URL of the speaker',
            'bio': 'Adjust the bio of the speaker',
            'twitter-handle': 'Adjust the bio of the speaker'
        },

        render: function() {
            var thisView = this;
            this.$el.empty();
            var agenda = this.model;
            var eventId = Global.modelPool.getActiveEvent().id || 'new';
            var html = [];
            _.each(this.model.dayErrors, function(dayErrors, dayCid) {
                _.each(dayErrors || {}, function(sessionErrors, sessionCid) {
                    var session = agenda.getSession(sessionCid);
                    var name = session && session.get('name');
                    var shouldValidate = (session.wasEdited || session.isSynced);
                    shouldValidate && _.each(sessionErrors || {}, function(errorMessage, field) {
                        var source = {
                            isSession: true,
                            cid: sessionCid,
                            eventId: eventId,
                            error: 'Session ' + errorMessage.toLowerCase(),
                            field: field,
                            instructions: thisView.sessionInstructions[field],
                            name: name
                        };
                        html.push(template(source));
                    });
                });
            });
            _.each(this.model.speakerErrors, function(speakerErrors, speakerCid) {
                var speaker = agenda.get('speaker').get(speakerCid);
                var name = speaker && speaker.getFullName();
                _.each(speakerErrors || {}, function(errorMessage, field) {
                    var source = {
                        isSpeaker: true,
                        cid: speakerCid,
                        eventId: eventId,
                        error: 'Speaker ' + errorMessage.toLowerCase(),
                        field: field,
                        instructions: thisView.speakerInstructions[field],
                        name: name
                    };
                    html.push(template(source));
                });
            });
            var numberOfDisplayedErrors = html.length;
            if (numberOfDisplayedErrors > 0) {
                html.unshift('<p class="agenda-errors-title">There are ' + numberOfDisplayedErrors + ' error(s) Left. Here\'s how to solve them:</p>');
            } else {
                html.unshift('<p class="agenda-errors-title">Awesome! The agenda has no errors.</p>');
            }

            this.$el.html(html.join(''));
            return this;
        }

    });

    return AgendaErrorsView;
});
